import React, { useEffect } from "react";
import knowledgeCenter from "../../asset/images/knowledge-center-dot.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useState } from "react";
import Header from "../../Components/Header";
import Sidebar from "../../Components/Sidebar";
import { FaqSideToggle } from "../../asset/js/custom.js";
import Previous from "../../../src/asset/images/prev_arrow.svg";
import Next from "../../../src/asset/images/next.svg";
import DarkPrevious from "../../../src/asset/images/arrow_left-dark.svg";
import DarkNext from "../../../src/asset/images/arrow_right-dark.svg";
import Insurance from "../../../src/asset/images/Faq/insurance.svg";
import Loan from "../../../src/asset/images/Faq/loan.svg";
import MutualFund from "../../../src/asset/images/Faq/mutual-funds.svg";
import Stocks from "../../../src/asset/images/Faq/stocks.svg";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar.js";

function FaqPage() {
  const knowledgeCenterCardSlider = {
    dots: true,
    arrows: false,
    autoplay: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 2,

    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const [isOpen, setOoen] = useState();

  function PillScrollRight() {
    document.getElementById("pills-tab").scrollLeft += 200;
  }
  function PillScrollLeft() {
    document.getElementById("pills-tab").scrollLeft -= 200;
  }

  useEffect(() => {
    FaqSideToggle();
  }, []);

  return (
    <>
      <Header />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar/>
      <main className id="main-content">
        <section className="knowledge-center">
          <div className="knowledge-heading-search row">
            <div className="col-sm-6 col-md-5 col-lg-5 col-xl-4">
              <h5 className="knowledge-center__heading">
                How Can We Help You ?
              </h5>
            </div>
            <form className="col-sm-6 col-md-6 col-lg-5 col-xl-5">
              <div className="search-box">
                <div className="form-group">
                  <input
                    type="text"
                    name="search-text"
                    className="input-st"
                    placeholder="Search here..."
                  />
                  <input
                    type="submit"
                    name="submit"
                    defaultValue="submit"
                    className="submit-btn"
                  />
                </div>
              </div>
            </form>
          </div>
          <Slider
            {...knowledgeCenterCardSlider}
            className="knowledge-center__card-slider"
          >
            <li className="card-item">
              <div className="card-box">
                <img
                  src={Insurance}
                  alt="knowledge-center-img"
                  className="knowledge-center-img"
                />
                <span className="card-slider-subtitle">Stocks</span>
              </div>
            </li>
            <li className="card-item">
              <div className="card-box">
                <img
                  src={Loan}
                  alt="knowledge-center-img"
                  className="knowledge-center-img"
                />
                <span className="card-slider-subtitle">Mutual Funds</span>
              </div>
            </li>
            <li className="card-item">
              <div className="card-box">
                <img
                  src={MutualFund}
                  alt="knowledge-center-img"
                  className="knowledge-center-img"
                />
                <span className="card-slider-subtitle">Insurance</span>
              </div>
            </li>
            <li className="card-item">
              <div className="card-box">
                <img
                  src={Stocks}
                  alt="knowledge-center-img"
                  className="knowledge-center-img"
                />
                <span className="card-slider-subtitle">Loans</span>
              </div>
            </li>
            <li className="card-item">
              <div className="card-box">
                <img
                  src={MutualFund}
                  alt="knowledge-cente
                  "
                  className="knowledge-center-img"
                />
                <span className="card-slider-subtitle">Insurance</span>
              </div>
            </li>
            <li className="card-item">
              <div className="card-box">
                <img
                  src={Stocks}
                  alt="knowledge-center-img"
                  className="knowledge-center-img"
                />
                <span className="card-slider-subtitle">Loans</span>
              </div>
            </li>
          </Slider>
          <div className="knowledge-accordion">
            <div className="page-tabs">
              {/* knowledge tab */}

              <div className="knowledge-tab">
                <img
                  src={Previous}
                  onClick={PillScrollLeft}
                  className="prev-img"
                ></img>
                <img
                  src={DarkPrevious}
                  onClick={PillScrollLeft}
                  className="dark-prev-img"
                ></img>
                <ul
                  className="nav nav-pills card-box"
                  id="pills-tab"
                  role="tablist"
                >
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link active"
                      id="pills-home-tab"
                      data-toggle="pill"
                      data-target="#pills-home"
                      type="button"
                      role="tab"
                      aria-controls="pills-home"
                      aria-selected="true"
                    >
                      Home Loan
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-personal-tab"
                      data-toggle="pill"
                      data-target="#pills-personal"
                      type="button"
                      role="tab"
                      aria-controls="pills-personal"
                      aria-selected="false"
                    >
                      Personal Loan
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-business-tab"
                      data-toggle="pill"
                      data-target="#pills-business"
                      type="button"
                      role="tab"
                      aria-controls="pills-business"
                      aria-selected="false"
                    >
                      Business Loan
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-pmayloan-tab"
                      data-toggle="pill"
                      data-target="#pills-pmayloan"
                      type="button"
                      role="tab"
                      aria-controls="pills-pmayloan"
                      aria-selected="false"
                    >
                      PMAY Loan
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-goldloan-tab"
                      data-toggle="pill"
                      data-target="#pills-goldloan"
                      type="button"
                      role="tab"
                      aria-controls="pills-goldloan"
                      aria-selected="false"
                    >
                      Gold Loan
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-loanproperty-tab"
                      data-toggle="pill"
                      data-target="#pills-loanproperty"
                      type="button"
                      role="tab"
                      aria-controls="pills-loanproperty"
                      aria-selected="false"
                    >
                      Loan Against Property
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-personalloan-tab"
                      data-toggle="pill"
                      data-target="#pills-personalloan"
                      type="button"
                      role="tab"
                      aria-controls="pills-personalloan"
                      aria-selected="false"
                    >
                      Personal Loan
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-businessloan-tab"
                      data-toggle="pill"
                      data-target="#pills-businessloan"
                      type="button"
                      role="tab"
                      aria-controls="pills-businessloan"
                      aria-selected="false"
                    >
                      Business Loan
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-pmayloansecond-tab"
                      data-toggle="pill"
                      data-target="#pills-pmayloansecond"
                      type="button"
                      role="tab"
                      aria-controls="pills-pmayloansecond"
                      aria-selected="false"
                    >
                      PMAY Loan
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-gold-tab"
                      data-toggle="pill"
                      data-target="#pills-gold"
                      type="button"
                      role="tab"
                      aria-controls="pills-gold"
                      aria-selected="false"
                    >
                      Gold Loan
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-againstproperty-tab"
                      data-toggle="pill"
                      data-target="#pills-againstproperty"
                      type="button"
                      role="tab"
                      aria-controls="pills-againstproperty"
                      aria-selected="false"
                    >
                      Loan Against Property
                    </button>
                  </li>
                  <li className="nav-item" role="presentation">
                    <button
                      className="nav-link"
                      id="pills-personal-tab"
                      data-toggle="pill"
                      data-target="#pills-personal"
                      type="button"
                      role="tab"
                      aria-controls="pills-personal"
                      aria-selected="false"
                    >
                      Personal Loan
                    </button>
                  </li>
                </ul>
                <img
                  src={Next}
                  onClick={PillScrollRight}
                  className="next-img"
                ></img>
                <img
                  src={DarkNext}
                  onClick={PillScrollRight}
                  className="dark-next-img"
                ></img>

                <span id="tab-arrow" className="knowledge-tab-arrow">
                  <span className="icon-arrow-left" />
                </span>
              </div>
              {/* knowledge data */}
              <div className="tab-content knowledge-data" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className="accordion-button"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                        >
                          What is a Home loan?
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className="accordion-collapse collapse show"
                        aria-labelledby="headingOne"
                        data-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Ipsa doloribus obcaecati accusantium.
                            Accusantium, impedit? At, consectetur alias nisi
                            impedit reprehenderit aut nam? Nulla inventore aut
                            veniam laboriosam perspiciatis quam! Reprehenderit?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingNine">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseNine"
                          aria-expanded="true"
                          aria-controls="collapseNine"
                        >
                          What is the Eligiblity criterion for Obtaining Home
                          Loan?
                        </button>
                      </h2>
                      <div
                        id="collapseNine"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingNine"
                        data-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Incidunt pariatur impedit commodi rem, natus
                            consequatur, nulla quidem repellat doloribus maiores
                            amet! Id optio labore consectetur molestiae minima
                            rem debitis inventore.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingTwo">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                        >
                          What are the documents required for Home Loan?
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingTwo"
                        data-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <ul>
                            <li> Signed Application form with a photograph</li>
                            <li>
                              Residence proof (Ration card, Electricity Bill,
                              etc)
                            </li>
                            <li> Bank statement from the last 6 months</li>
                          </ul>
                          <p>
                            {" "}
                            The above are the general documents. However, If you
                            are salaried, then you need to provide additional
                            documents (Photocopies) mentioned below:-
                          </p>
                          <ul>
                            <li> KYC - PAN Card and Aadhar Card</li>
                            <li> Salary slips from the last 3 months</li>
                            <li>Form 16 or your Income Tax returns</li>
                            <li>
                              {" "}
                              Sanction Letters of Existing Loan (Optional)
                            </li>
                          </ul>
                          <p>
                            If you are self-employed, then you need to provide
                            additional documents mentioned below:-
                          </p>
                          <ul>
                            <li>
                              {" "}
                              Income Tax Returns from the last 3 years with
                              Income computation
                            </li>
                            <li>
                              Balance sheet and Profit and Loss account which is
                              CA certified or audited from the last 3 years
                            </li>
                            <li>
                              {" "}
                              Business Stability Proof(Shop &amp; establishment
                              certificate / Trade license certificate / Factory
                              registration certificate)
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingThree">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                        >
                          Who can Avail a Home Loan?
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingThree"
                        data-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Incidunt pariatur impedit commodi rem, natus
                            consequatur, nulla quidem repellat doloribus maiores
                            amet! Id optio labore consectetur molestiae minima
                            rem debitis inventore.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingFourth">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseFourth"
                          aria-expanded="false"
                          aria-controls="collapseFourth"
                        >
                          What is tenure of repayment of Home Loan?
                        </button>
                      </h2>
                      <div
                        id="collapseFourth"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingFourth"
                        data-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Incidunt pariatur impedit commodi rem, natus
                            consequatur, nulla quidem repellat doloribus maiores
                            amet! Id optio labore consectetur molestiae minima
                            rem debitis inventore.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingFive">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                        >
                          What is the Minimum &amp; Maximum age to avail Home
                          Loan?
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingFive"
                        data-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Incidunt pariatur impedit commodi rem, natus
                            consequatur, nulla quidem repellat doloribus maiores
                            amet! Id optio labore consectetur molestiae minima
                            rem debitis inventore.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingSix">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseSix"
                          aria-expanded="false"
                          aria-controls="collapseSix"
                        >
                          What is the Minimum income criteria to obtain a Home
                          Loan?
                        </button>
                      </h2>
                      <div
                        id="collapseSix"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingSix"
                        data-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Incidunt pariatur impedit commodi rem, natus
                            consequatur, nulla quidem repellat doloribus maiores
                            amet! Id optio labore consectetur molestiae minima
                            rem debitis inventore.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingSeven">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseSeven"
                          aria-expanded="false"
                          aria-controls="collapseSeven"
                        >
                          What are the types of Home Loan?
                        </button>
                      </h2>
                      <div
                        id="collapseSeven"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingSeven"
                        data-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Incidunt pariatur impedit commodi rem, natus
                            consequatur, nulla quidem repellat doloribus maiores
                            amet! Id optio labore consectetur molestiae minima
                            rem debitis inventore.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingEighth">
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-toggle="collapse"
                          data-target="#collapseEighth"
                          aria-expanded="true"
                          aria-controls="collapseEighth"
                        >
                          What are the rate of interest of Home Loan?
                        </button>
                      </h2>
                      <div
                        id="collapseEighth"
                        className="accordion-collapse collapse"
                        aria-labelledby="headingEighth"
                        data-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          <p>
                            Lorem ipsum dolor sit amet consectetur adipisicing
                            elit. Incidunt pariatur impedit commodi rem, natus
                            consequatur, nulla quidem repellat doloribus maiores
                            amet! Id optio labore consectetur molestiae minima
                            rem debitis inventore.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-personal"
                  role="tabpanel"
                  aria-labelledby="pills-personal-tab"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-business"
                  role="tabpanel"
                  aria-labelledby="pills-business-tab"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-pmayloan"
                  role="tabpanel"
                  aria-labelledby="pills-pmayloan-tab"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-goldloan"
                  role="tabpanel"
                  aria-labelledby="pills-goldloan-tab"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-loanproperty"
                  role="tabpanel"
                  aria-labelledby="pills-loanproperty-tab"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-personalloan"
                  role="tabpanel"
                  aria-labelledby="pills-personalloan-tab"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-businessloan"
                  role="tabpanel"
                  aria-labelledby="pills-businessloan-tab"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-pmayloansecond"
                  role="tabpanel"
                  aria-labelledby="pills-pmayloansecond-tab"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-gold"
                  role="tabpanel"
                  aria-labelledby="pills-gold-tab"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-againstproperty"
                  role="tabpanel"
                  aria-labelledby="pills-againstproperty-tab"
                >
                  ...
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-personal"
                  role="tabpanel"
                  aria-labelledby="pills-personal-tab"
                >
                  ...
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
export default FaqPage;
